var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('ul',{staticClass:"nav nav-tabs"},_vm._l((_vm.data),function(item,key){return _c('li',{key:key,class:{ 'active': _vm.currentTab === item.id },on:{"click":function($event){_vm.handleChangeTab(item.id)}}},[_c('a',[_vm._v(_vm._s(item.title))])])}),0)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-244aba32","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/view/premium/components/NavTabs.vue
// module id = null
// module chunks = 